var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('PersonalInfo'),_c('a',{attrs:{"id":"beian","href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("粤ICP备20010815号-1")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }